import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { OverrideProvider } from '@override';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ToastContainer } from 'react-toastify';

import { RECAPTCHA_SITE_KEY } from '@constants';
import { queryClient } from '@hooks/queryClient';
import { mantineTheme } from '@styles';
import { ProgressProvider } from '../../../packages/frontend/src/hooks/ProgressContext';
import { Navigation } from './navigation';
import { useOverridesModule } from './overrides';

export const App = () => {
  const overrideRegistry = useOverridesModule();
  return (
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
      <MantineProvider theme={mantineTheme} withCssVariables>
        <QueryClientProvider client={queryClient}>
          <OverrideProvider registry={overrideRegistry}>
            <ProgressProvider>
              <ModalsProvider
                modalProps={{
                  centered: true,
                  closeOnClickOutside: true,
                  closeOnEscape: true,
                  styles: {
                    header: {
                      borderBottom: '1px solid rgb(222, 222, 222)',
                      marginBottom: mantineTheme?.spacing?.md,
                    },
                  },
                }}
              >
                <Navigation />
                <ToastContainer position="bottom-left" autoClose={5000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss={false} />
              </ModalsProvider>
            </ProgressProvider>
          </OverrideProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </MantineProvider>
    </GoogleReCaptchaProvider>
  );
};
